import React from 'react';
import { Icon } from './Icon.js';
export const IconFarm = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8 21V15H16V21", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M3 15L3 21H21V15", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M19.7143 4.57143L12 2L4.28571 4.57143L3 11H21L19.7143 4.57143Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" })));
};
//# sourceMappingURL=IconFarm.js.map